/**
 * Agent Review Service (Frontend)
 * API client for agent reviews.
 */

import apiClient from './apiClient';

class AgentReviewService {
  async getReviewSummary(rolId) {
    return apiClient.get(`/api/roles/${rolId}/reviews/summary`);
  }

  async getMyReview(rolId) {
    return apiClient.get(`/api/roles/${rolId}/reviews/mine`);
  }

  async upsertReview(rolId, { rating, comment }) {
    return apiClient.put(`/api/roles/${rolId}/reviews`, { rating, comment });
  }

  async deleteReview(rolId) {
    return apiClient.delete(`/api/roles/${rolId}/reviews`);
  }
}

export default new AgentReviewService();
